import React from 'react';
import {Image, ImageProps} from '../../elements/images/Image';
import styled from 'styled-components';
import {useBreakpointDown} from 'epic-ue-theme';

interface ImgPositionProps {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
}

const BeveledImageWrapper = styled.div<ImgPositionProps>`
    background-color: ${(p) =>
        p.theme.ifLight(p, p.theme.palette.neutral.stone, p.theme.palette.neutral.chalk)};
    box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: ${(p) => p.theme.spacing(3)}px;
    z-index: 100;
    ${(p) => p.theme.breakpoints.up('xs')} {
        width: ${(p) => p.theme.spacing(12)}px;
        height: ${(p) => p.theme.spacing(12)}px;
    }
    ${(p) => p.theme.breakpoints.up('md')} {
        width: ${(p) => p.theme.spacing(13.25)}px;
        height: ${(p) => p.theme.spacing(13.25)}px;
    }
    ${(p) => p.theme.breakpoints.up('lg')} {
        width: ${(p) => p.theme.spacing(16)}px;
        height: ${(p) => p.theme.spacing(16)}px;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: ${(p) => p.top}px;
    right: ${(p) => p.right}px;
    bottom: ${(p) => p.bottom}px;
    left: ${(p) => p.left}px;
`;

export interface BeveledImageProps {
    image: ImageProps;
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
}

export const BeveledImage = (props: BeveledImageProps): JSX.Element => {
    const {image, top, right, bottom, left} = props;
    const isSm = useBreakpointDown('sm');
    const isMd = useBreakpointDown('md');

    let dimensions = 75;
    if (isMd) {
        dimensions = 62;
    } else if (isSm) {
        dimensions = 58;
    }

    return (
        <BeveledImageWrapper
            className="beveled-image"
            top={top}
            right={right}
            bottom={bottom}
            left={left}>
            <Image
                src={image.src}
                ratio="square"
                fit="contain"
                width={dimensions}
                height={dimensions}
                alt={image.alt}
            />
        </BeveledImageWrapper>
    );
};
